import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { useMemo } from "react";
import { UserWebTypeEnum } from "types/enums";

export const useTenantWebTypeSelectOptions = () => {
    const { t } = usePaldockTranslation("general.tenant_web_type");

    const options = useMemo(
        () =>
            Object.values(UserWebTypeEnum).map((value) => ({
                label: t(value),
                value: value,
            })),
        [t]
    );

    return { options, loading: false, error: null };
};
